import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { RadioGroup } from "@website/ui/radio-group";
import { ReserveCommentFilterItemTypes } from "@website/widget/reserve-comment-popup-scroll/reserve-comment-filter/reserve-comment-filter-item/reserve-comment-filter-item.types";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
export const ReserveCommentsSort = t0 => {
  const $ = _c(26);
  const {
    startIconName,
    filterName,
    radioItems,
    onLoadFilter,
    isInsideDetail
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== startIconName) {
    t1 = <MaterialIcon name={startIconName} />;
    $[0] = startIconName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = filterName?.fa;
  let t3;
  if ($[2] !== router) {
    t3 = () => router.push({
      pathname: router.pathname,
      query: {
        ...router?.query,
        popover: "sort"
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[2] = router;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <Button variant="text" color="neutral" StartIcon={t1} text={t2} onClick={t3} />;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== router) {
    t5 = () => router.push({
      pathname: router.pathname,
      query: omit(router?.query, "popover")
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[8] = router;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = router.query?.popover === "sort";
  const t7 = filterName?.fa;
  let t8;
  if ($[10] !== isInsideDetail || $[11] !== onLoadFilter || $[12] !== router) {
    t8 = event => {
      router.push({
        pathname: router.pathname,
        query: {
          ...omit(router?.query, "popover"),
          order_by: event.target?.value
        }
      }, undefined, {
        shallow: true,
        scroll: false
      });
      return onLoadFilter ? onLoadFilter({
        order_by: String(event.target?.value)
      }, isInsideDetail) : null;
    };
    $[10] = isInsideDetail;
    $[11] = onLoadFilter;
    $[12] = router;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = router?.query?.order_by;
  let t10;
  if ($[14] !== radioItems || $[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
    t10 = <RadioGroup className="text-subtitle-2 flex-col px-6 py-4" color="secondary" items={radioItems} name={t7} onChange={t8} value={t9} />;
    $[14] = radioItems;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t5 || $[21] !== t6) {
    t11 = <MiniPopover animate="bottom" className="left-0" defaultHorizontalPosition="end" onClose={t5} open={t6} title={"\u0645\u0631\u062A\u0628\u200C\u0633\u0627\u0632\u06CC"}>{t10}</MiniPopover>;
    $[19] = t10;
    $[20] = t5;
    $[21] = t6;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t4) {
    t12 = <div className="relative">{t4}{t11}</div>;
    $[23] = t11;
    $[24] = t4;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
};